<template>
  <ColorPicker :value="color" @change="$emit('confirm', $event)">
    <template v-slot:trigger>
      <EditorButton :title="tooltip">
        <slot />
      </EditorButton>
    </template>
  </ColorPicker>
</template>

<script>
import ColorPicker from '@components/color-picker.vue'
import EditorButton from './editor-button'

export default {
  name: 'ColorButton',
  components: { EditorButton, ColorPicker },
  props: {
    tooltip: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      color: '',
    }
  },
  methods: {
    handleShowPopover() {
      this.color = ''
    },
    handleFormSubmit() {
      this.$emit('confirm', this.color)
      this.hideMenu()
    },
    hideMenu() {
      this.$emit('hide')
      this.$refs.popover.hide()
    },
  },
}
</script>
